import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterDateBetween, FilterValue, FilterValueCollection } from '@hub/generated/models';
import { SearchController } from '@hub/generated/services';

@Component({
  selector: 'f-filterDateBetween',
  templateUrl: './filterDateBetween.component.html',
  styleUrls: ['./filterDateBetween.component.scss']
})
export class FilterDateBetweenComponent implements OnInit {
  // Constructors
  constructor (private controller: SearchController) {
  }

  // Constants
  private readonly _fromDateMarker: string = "FromDate";
  private readonly _toDateMarker: string = "ToDate";
  yearRange: string = '2000:2035';
  
  // Properties
  @Input()
  public filter: FilterDateBetween;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.setValues();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public fromDate: Date;
  public toDate: Date;
  public columnName: string;

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.setValues();
  }

  public onChange() {
    let result: FilterValueCollection = new FilterValueCollection();
    result.List = [];

    result.ColumnName = this.columnName;
    if (this.fromDate) {
      let value: FilterValue = { Key: this._fromDateMarker, Value: this.fromDate.toDateString(), EntityType: null };
      result.List.push(value);
    }

    if (this.toDate) {
      let value: FilterValue = { Key: this._toDateMarker, Value: this.toDate.toDateString(), EntityType: null };
      result.List.push(value);
    }

    if (!this.fromDate && !this.toDate) {
      result.List = [];
    }

    this.ondataChange.emit(result);
  }

  private setValues(): void
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length) {
        let fromValue = values.List.filter(item => item.Key === this._fromDateMarker);
        if (!!fromValue && fromValue.length > 0)
          this.fromDate = new Date(fromValue[0].Value);

        let toValue = values.List.filter(item => item.Key === this._toDateMarker);
        if (!!toValue && toValue.length > 0)
          this.toDate = new Date(toValue[0].Value);
      }
    }

    return null;
  }
}
